export const clientIdCookieName = 'agromarket_client_id'
